import axios from 'axios'
import ReactOnRails from 'react-on-rails'
import RouteMap from '../assets/RouteMap.js'

import {
    RECRUITING_COMPANIES_API,
    SIMILAR_COMPANIES_API,
    FILTER_COMPANY_JOBS_API,
    COMPANY_API,
    JOIN_PARENT_COMPANY_API
} from './env'

const JoinParentCompany = (data) => {
    return axios({
        url: JOIN_PARENT_COMPANY_API,
        method: 'post',
        data: {
            parent_id: data.selectedCompanyId,
            child_company_id: data.companyId
        }
    })
}

function CompanyProfileUpdate (data) {
    return axios({
        url: COMPANY_API,
        method: 'patch',
        data: data
    })
}

const GetRecruitingCompanies = (data) => {
    return axios({
        url: RECRUITING_COMPANIES_API,
        method: 'get',
        params: {
            locale: RouteMap.GetLocaleFromUrl(),
            ...data
        }
    })
}

const GetSimilarCompanies = (data) => {
    return axios({
        url: SIMILAR_COMPANIES_API,
        method: 'get',
        params: {
            locale: RouteMap.GetLocaleFromUrl(),
            ...data
        }
    })
}

const GetCompanyJobs = (data) => {
    return axios({
        url: FILTER_COMPANY_JOBS_API,
        method: 'post',
        data: {
            locale: RouteMap.GetLocaleFromUrl(),
            ...data
        }
    })
}

export default {
    GetCompanyJobs,
    CompanyProfileUpdate,
    JoinParentCompany,
    GetRecruitingCompanies,
    GetSimilarCompanies
}
